import React, { Fragment } from 'react';
import NavbarS4 from '../../components/NavbarS4/NavbarS4';
import PageTitle from '../../components/pagetitle/PageTitle'
import ScrollTextAnimation from '../../components/ScrollTextAnimation/ScrollTextAnimation';
import About from '../../components/about/about';
import ServiceSection from '../../components/ServiceSection/ServiceSection';
import FunFact from '../../components/FunFact/FunFact';
import PartnerSection from '../../components/PartnerSection/PartnerSection';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo2.png'
import TeamSection from '../../components/TeamSection/TeamSection';
import SEO from '../../components/Seo';


const AboutPage = () => {
    return (
        <Fragment>
            <SEO
                title="About LuxRock Realty | Trusted Real Estate Company"
                description="LuxRock Realty is a trusted real estate consultancy helping buyers and investors find the right property with transparency and expert guidance."
                keywords="about LuxRock Realty, real estate consultant, property advisor"
            />

            <NavbarS4 hclass={'wpo-site-header wpo-header-style-s11'} Logo={Logo} col1={'col-lg-3 col-md-3 col-3 d-lg-none dl-block'}
                col2={'col-lg-2 col-md-4 col-6'}
                col3={'col-lg-7 col-md-1 col-1'}
                col4={'col-lg-3 col-md-4 col-2'} />
            <PageTitle pageTitle={'Your Trusted Real Estate Partner'} pagesub={'About Us'} />

            <ScrollTextAnimation />
            <About hclass={"wpo-about-section section-padding pb-0"} />
            {/* <ProjectSection hclass={'wpo-project-section section-padding'} /> */}
            <ServiceSection hclass={'wpo-service-section'} />
            <FunFact hclass={'wpo-funfact-section'} />
            <TeamSection hclass={'wpo-team-section'} />

            <PartnerSection hclass={'wpo-partners-section fade_bottom'} />
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default AboutPage;
